import { create } from 'zustand'

/**
 * Drives the ~1s accent-color flash when a thread's auto-title changes, so the
 * user notices the title moved (row, header, and composer scope line all read
 * from the same refetched `ThreadSummary.title`). Keyed by thread id; a flash
 * records the wall-clock instant it fired so consumers can ignore stale ones.
 */
const FLASH_MS = 1100

interface ThreadTitleState {
  flashAt: Record<string, number>
  flash: (threadId: string) => void
}

export const useThreadTitleFlash = create<ThreadTitleState>((set) => ({
  flashAt: {},
  flash: (threadId) => {
    set((s) => ({ flashAt: { ...s.flashAt, [threadId]: Date.now() } }))
    setTimeout(() => {
      set((s) => {
        if (!s.flashAt[threadId]) return s
        const next = { ...s.flashAt }
        delete next[threadId]
        return { flashAt: next }
      })
    }, FLASH_MS)
  },
}))
